module.exports = __webpack_public_path__ + "media/images/aboutus-693fa79af0812f8dcd0c3bc4007960a7.svg";